import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useSnackbarContext, TablePagination } from '@ohif/ui';
import {
  getAiList,
  saveAiStatus,
  getDicCheckList,
  addAi,
  getAiPathList,
  saveAiVisible,
} from './makeData';
import './WindowLevelPreferences.styl';

import './LanguageSwitcher.styl';
import AIPathSelect from '../AIPathSelect/AIPathSelect';

// Contexts
import AppContext from '../../context/AppContext';

function AiPathSetting({ onClose }) {
  //getAiListSection(null, 10, 0);
  const { appConfig = {} } = useContext(AppContext);
  const [aiAds, setAiIds] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);
  const [dicCheckId, setDicCheckId] = useState(0);
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectAiOptions, setSelectAiOptions] = useState([]);
  const [visible, setVisible] = useState(0);
  const [aiAppName, setAiAppName] = useState('');
  const [status, setStatus] = useState(0);
  const [show, setShow] = useState(false);
  const [flags, setFlags] = useState(false);

  useEffect(() => {
    const fetchTableData = async () => {
      //获取检查项目
      if (!selectOptions.length) {
        const data = await getDicCheckList(appConfig);
        if (data && data.data.length > 0) {
          setSelectOptions(data.data);
          if (!dicCheckId) {
            setDicCheckId(data.data[0].id);
          }
        }
      }

      if (dicCheckId) {
        const tableData = await getAiPathList(
          dicCheckId,
          rowsPerPage,
          pageNumber,
          appConfig
        );
        if (tableData && tableData.data) {
          setTableData(tableData.data.records);
          setTotal(tableData.data.total);
          const aiIds = [];
          tableData.data.records.forEach(record => {
            aiIds.push(record.myAiInfo.myAiInfoId);
          });
          setAiIds(aiIds);
        }
      }

      if (!selectAiOptions.length) {
        const test = await getAiList(
          dicCheckId,
          rowsPerPage,
          pageNumber,
          appConfig
        );
        setSelectAiOptions(test.data);
      }
    };
    fetchTableData();
  }, [
    dicCheckId,
    rowsPerPage,
    pageNumber,
    selectOptions.length,
    selectAiOptions.length,
    appConfig,
  ]);

  const snackbar = useSnackbarContext();

  const onSelectChange = event => {
    const { value } = event.target;
    setAiAppName(value);
  };
  const onStatusChange = event => {
    const { value } = event.target;
    if (value == 1) {
      setVisible(1);
    }
    setStatus(value);
  };
  const onVisileChange = event => {
    const { value } = event.target;
    setVisible(value);
  };

  const styleDialog = {
    background: '#efefef',
    height: 40,
    color: '#000',
    menuListBackground: '#91B9CD',
    placeholderColor: '#000',
  };

  const selectAi = e => {
    setDicCheckId(e.id);
  };

  return (
    <React.Fragment>
      <div
        style={{
          marginLeft: '20px',
          marginTop: '20px',
          display: 'inlineBlock',
        }}
      >
        <div
          style={{
            width: '100%',
          }}
        >
          <AIPathSelect
            callbackAICheckPath={selectAi}
            appConfig={appConfig}
            device={'CT'}
            id={-1}
            name={''}
            isAll={'no'}
            inDialog={true}
            styleDialog={styleDialog}
          />
        </div>

        <button
          style={{
            height: '40px',
            float: 'right',
            marginTop: '-40px',
            marginRight: '5px',
          }}
          onClick={() => {
            //开启新增
            if (!flags) {
              setShow(true);
              setFlags(true);
            } else {
              let payload = {
                aiInfoId: aiAppName ? aiAppName : selectAiOptions[0].myAiInfoId,
                dicCheckId: dicCheckId,
                status: status ? 1 : 0,
                viewResult: visible ? 1 : 0,
              };

              addAi(payload, appConfig).then(data => {
                getAiPathList(
                  dicCheckId,
                  rowsPerPage,
                  pageNumber,
                  appConfig
                ).then(data => {
                  if (tableData) {
                    setTableData(data.data.records);
                    setTotal(data.data.total);
                  }
                });

                setShow(false);
                setFlags(false);
                snackbar.show({
                  message: 'Ai追加成功',
                  type: 'success',
                });
              });
            }
          }}
        >
          {!flags ? '新增' : '保存'}
        </button>
      </div>
      <div className="WindowLevelPreferences">
        <div className="wlColumn">
          <div className="wlRow header">
            <div className="wlColumn preset">序号</div>
            <div className="wlColumn description">AI应用</div>
            <div className="wlColumn window">启停用</div>
            <div className="wlColumn level">结果</div>
          </div>

          {show && (
            <div className="wlRow">
              <div className="wlColumn preset"></div>

              <div className="wlColumn description">
                <select
                  name="language-select"
                  id="language-select"
                  className="language-select"
                  value={aiAppName}
                  onChange={onSelectChange}
                  style={{
                    height: '40px',
                    marginLeft: '20px',
                  }}
                >
                  {selectAiOptions.map(lng => (
                    <option
                      disabled={aiAds.indexOf(lng.myAiInfoId) != -1}
                      key={lng.myAiInfoId}
                      value={lng.myAiInfoId}
                    >
                      {lng.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="wlColumn window">
                <select
                  name="language-select"
                  id="language-select"
                  className="language-select"
                  value={status}
                  onChange={onStatusChange}
                  style={{
                    height: '40px',
                    marginLeft: '20px',
                  }}
                >
                  <option key={0} value={0}>
                    启用
                  </option>
                  <option key={1} value={1}>
                    停用
                  </option>
                </select>
              </div>

              <div className="wlColumn level">
                <select
                  name="language-select"
                  id="language-select"
                  className="language-select"
                  value={visible}
                  onChange={onVisileChange}
                  style={{
                    height: '40px',
                    marginLeft: '20px',
                  }}
                >
                  <option key={0} value={0}>
                    显示
                  </option>
                  <option key={1} value={1}>
                    隐藏
                  </option>
                </select>
              </div>
            </div>
          )}
          {tableData &&
            Object.keys(tableData).map((key, index) => {
              return (
                <div className="wlRow" key={key}>
                  <div className="wlColumn preset">{parseInt(key) + 1}</div>

                  <div className="wlColumn description">
                    <input
                      type="text"
                      className="preferencesInput"
                      value={tableData[key].myAiInfo.name}
                      data-key={key}
                      data-inputname="description"
                      disabled={true}
                    />
                  </div>

                  <div className="wlColumn window">
                    <button
                      className="preferencesInput"
                      onClick={() => {
                        console.log(tableData[key]);
                        tableData[key].userVsAiSetting.status =
                          tableData[key].userVsAiSetting.status == '0' ? 1 : 0;
                        if (tableData[key].userVsAiSetting.status == '1') {
                          tableData[key].userVsAiSetting.viewResult = '1';
                        }
                        saveAiStatus(
                          tableData[key].userVsAiSetting,
                          appConfig
                        ).then(data => {
                          console.log(data);
                          if (tableData[key].userVsAiSetting.status) {
                            snackbar.show({
                              message: 'Ai停用成功',
                              type: 'success',
                            });
                          } else {
                            snackbar.show({
                              message: 'Ai启用成功',
                              type: 'success',
                            });
                          }
                          if (tableData[key].userVsAiSetting.status == '1') {
                            tableData[key].userVsAiSetting.viewResult = 1;
                            saveAiVisible(
                              tableData[key].userVsAiSetting,
                              appConfig
                            ).then(data => {
                              getAiPathList(
                                dicCheckId,
                                rowsPerPage,
                                pageNumber,
                                appConfig
                              ).then(data => {
                                if (tableData) {
                                  setTableData(data.data.records);
                                  setTotal(data.data.total);
                                }
                              });
                            });
                          } else {
                            getAiPathList(
                              dicCheckId,
                              rowsPerPage,
                              pageNumber,
                              appConfig
                            ).then(data => {
                              if (tableData) {
                                setTableData(data.data.records);
                                setTotal(data.data.total);
                              }
                            });
                          }
                        });
                      }}
                    >
                      {tableData[key].userVsAiSetting.status == '0'
                        ? '启用'
                        : '停用'}
                    </button>
                  </div>

                  <div className="wlColumn level">
                    <button
                      className="preferencesInput"
                      disabled={tableData[key].userVsAiSetting.status == '1'}
                      onClick={() => {
                        tableData[key].userVsAiSetting.viewResult =
                          tableData[key].userVsAiSetting.viewResult == '1'
                            ? 0
                            : 1;
                        saveAiVisible(
                          tableData[key].userVsAiSetting,
                          appConfig
                        ).then(data => {
                          if (tableData[key].userVsAiSetting.viewResult) {
                            snackbar.show({
                              message: '设置Ai结果隐藏成功',
                              type: 'success',
                            });
                          } else {
                            snackbar.show({
                              message: '设置Ai结果可见成功',
                              type: 'success',
                            });
                          }
                          getAiPathList(
                            dicCheckId,
                            rowsPerPage,
                            pageNumber,
                            appConfig
                          ).then(data => {
                            if (tableData) {
                              setTableData(data.data.records);
                              setTotal(data.data.total);
                            }
                          });
                        });
                      }}
                    >
                      {tableData[key].userVsAiSetting.viewResult == '0' ? (
                        <svg
                          width="18px"
                          height="12px"
                          viewBox="0 0 18 12"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <title>眼睛 (1)备份</title>
                          <g
                            id="页面-1"
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd"
                          >
                            <g
                              id="Viewer---2.0-1备份"
                              transform="translate(-1148.000000, -274.000000)"
                              fill="#8ECFFD"
                              fillRule="nonzero"
                            >
                              <g
                                id="编组-8"
                                transform="translate(737.000000, 145.000000)"
                              >
                                <g
                                  id="眼睛-(1)备份"
                                  transform="translate(411.000000, 129.000000)"
                                >
                                  <path
                                    d="M8.99999999,1.45454545 C12.3409197,1.45454545 15.3834174,4.69949769 16.5454545,6.09090909 C15.3834174,7.4823205 12.3409197,10.7272727 8.99999999,10.7272727 C5.6590803,10.7272727 2.61658263,7.4823205 1.45454545,6.09090909 C2.61658263,4.69949769 5.65908032,1.45454545 8.99999999,1.45454545 Z M9,0 C4.87402399,0 1.37804431,3.93699999 0.199051162,5.43250001 C-0.0663503873,5.76428787 -0.0663503873,6.23571213 0.199051162,6.56749999 C1.37804431,8.06300001 4.87402399,12 9,12 C13.125976,12 16.6219557,8.06299999 17.8009488,6.56749999 C18.0663504,6.23571213 18.0663504,5.76428787 17.8009488,5.43250001 C16.6219557,3.93699999 13.125976,0 9,0 Z M9,4.72727273 C9.75303031,4.72727273 10.3636364,5.33770922 10.3636364,6.09090909 C10.3636364,6.84410896 9.75303031,7.45454545 9,7.45454545 C8.24696969,7.45454545 7.63636364,6.84410896 7.63636364,6.09090909 C7.63636364,5.33770922 8.24696969,4.72727273 9,4.72727273 Z M9.09074512,3.27272727 C7.98764849,3.27272727 6.99314426,3.93713407 6.57140175,4.95664632 C6.14915414,5.97615859 6.38250151,7.14884395 7.16234637,7.92899247 C7.93192314,8.70703988 9.11367307,8.94205476 10.1342422,8.52001409 C11.1534954,8.09841867 11.8181818,7.10353231 11.8181818,6.00029197 C11.8181818,4.49367939 10.5974014,3.27272727 9.09125021,3.27272727 L9.09074512,3.27272727 Z"
                                    id="形状"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      ) : null}

                      {tableData[key].userVsAiSetting.viewResult == '1' ? (
                        <svg
                          width="18px"
                          height="9px"
                          viewBox="0 0 18 9"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <title>闭眼</title>
                          <g
                            id="页面-1"
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd"
                          >
                            <g
                              id="Viewer---2.0-1备份"
                              transform="translate(-1148.000000, -237.000000)"
                              fill="#8ECFFD"
                              fillRule="nonzero"
                            >
                              <g
                                id="编组-8"
                                transform="translate(737.000000, 145.000000)"
                              >
                                <g
                                  id="闭眼"
                                  transform="translate(411.000000, 92.000000)"
                                >
                                  <path
                                    d="M17.8881429,1.05717857 C18.0760869,0.765856415 18.0212965,0.380679273 17.7595714,0.153321429 C17.4702857,-0.0729642857 17.0832857,-0.00867857143 16.8582857,0.281892857 C16.8261429,0.314035714 13.2531429,4.54532143 9.00385714,4.54532143 C4.88314286,4.54532143 1.14942857,0.281892857 1.11728571,0.24975 C0.882849698,-0.010198022 0.484957461,-0.0385783528 0.216,0.185464286 C-0.043004836,0.421412938 -0.0712891603,0.819090537 0.151714286,1.08932143 C0.214714286,1.18703571 0.987428571,2.05875 2.21142857,3.02689286 L0.569571429,4.73946429 C0.450521835,4.86187898 0.38663203,5.0276045 0.392700655,5.19825424 C0.39876928,5.36890399 0.474269828,5.52967253 0.601714286,5.64332143 C0.666,5.77189286 0.826714286,5.83746429 0.987428571,5.83746429 C1.15748367,5.83613826 1.3197798,5.76611907 1.43742857,5.64332143 L3.20785714,3.80217857 C4.11295608,4.43485696 5.09778788,4.9449981 6.13671429,5.31932143 L5.46171429,7.61303571 C5.41203606,7.77999474 5.43195259,7.95994519 5.51693857,8.11199987 C5.60192454,8.26405455 5.74476333,8.37530164 5.913,8.42048549 L6.10585714,8.42048549 C6.39844295,8.42286547 6.65318159,8.22110819 6.71785714,7.93575 L7.39285714,5.64332143 C7.90842857,5.73975 8.45485714,5.80532143 9.00257143,5.80532143 C9.55028571,5.80532143 10.0967143,5.74103571 10.6122857,5.64332143 L11.2885714,7.90360714 C11.3528571,8.19417857 11.6421429,8.38832143 11.9005714,8.38832143 C11.9648571,8.38832143 12.0291429,8.38832143 12.0612857,8.35617857 C12.2293229,8.31070172 12.3719302,8.19940105 12.4568621,8.04744308 C12.5417941,7.89548511 12.5618775,7.71570378 12.5125714,7.54875 L11.8362857,5.28846429 C12.8754981,4.91423876 13.8603971,4.40363044 14.7651429,3.77003571 L16.5034286,5.57903571 C16.632,5.70760714 16.7927143,5.77317857 16.9547143,5.77317857 C17.1247694,5.77185255 17.2870655,5.70183336 17.4047143,5.57903571 C17.654741,5.33452634 17.6688838,4.93683067 17.4368571,4.67517857 L15.795,2.96389286 C17.1154286,1.99446429 17.8881429,1.05717857 17.8881429,1.05717857 L17.8881429,1.05717857 Z"
                                    id="路径"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      ) : null}
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div className="WindowLevelPreferences">
        <div className="wlColumn"></div>
      </div>
      <TablePagination
        currentPage={pageNumber}
        nextPageFunc={() => setPageNumber(pageNumber + 1)}
        prevPageFunc={() => setPageNumber(pageNumber - 1)}
        onRowsPerPageChange={Rows => setRowsPerPage(Rows)}
        rowsPerPage={rowsPerPage}
        recordCount={total}
      />
    </React.Fragment>
  );
}

AiPathSetting.propTypes = {
  onClose: PropTypes.func,
};

export { AiPathSetting };
